import * as React from 'react';
import { observer, inject } from "mobx-react";
import { Button, TextField, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';

// =====================================
// CONSTS
import { Messages } from '../../const/Messages';

// =====================================
// STORES
import { IArticleStore } from '../../store/ArticleStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';

@inject((allStores: any) => ({
    articleStore: allStores.store.articleStore as IArticleStore
}))

@observer
export default class DetailsOrderingArticles extends React.Component<{ articleStore?: IArticleStore; customerId?: any; isEditOrder?: any; orderId?: any; }, any> {
    render() {
        return (
            <div>
                <Header
                    title='Artikli za poručivanje'
                    isBackButtonVisible={true}
                    samePageAction={this.props.articleStore.handleShowModal} />

                <div className="container">

                    {this.props.articleStore.favorites.map((article, i) => {
                        return <div className="article" key={i}>
                            <div>
                                <div className="article-row">{article.code}</div>
                                <div className="article-row">{article.name}</div>
                                <div>Osnovna cena: {article.acquisitionPrice.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RSD</div>

                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className="add-btn"
                                        onClick={() => { this.props.articleStore.showInputForPriceChange(article) }}
                                        startIcon={<EditIcon />}
                                    >Promeni cenu
                                    </Button>
                                    {(this.props.articleStore.selectedRowId === article.id || article.customSalesPrice !== "") ?
                                        <div>
                                            <TextField
                                                type="number"
                                                label="Posebna cena"
                                                className="article-form-input"
                                                value={article.customSalesPrice}
                                                onChange={(event) => { this.props.articleStore.handleChangeAcquisitionPrice(event, article.id) }} />
                                        </div> : null}
                                </div>
                            </div>
                        </div>
                    })}

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="save-btn"
                        onClick={() => { this.props.articleStore.saveFavorite(this.props.customerId, this.props.orderId) }}
                        startIcon={<SaveIcon />}
                    >Snimi
                    </Button>
                </div>

                <Dialog
                    open={this.props.articleStore.isModalVisible}
                    onClose={this.props.articleStore.handleCloseModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle>{"Otkazivanje izmena"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {Messages.CANCEL_PRICE_CHANGE}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.articleStore.handleCloseModal} color="primary">
                            NE
                        </Button>
                        <Button onClick={this.props.articleStore.goBackToAricles} color="primary" autoFocus>
                            DA
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}